<i18n src="../../locales/lang.json"></i18n>

<template>
  <div v-bind:id="getId()" style="" class="text-center animated bounceIn filterbutton-container" v-bind:class="classes">
    <div v-bind:id="'menu' + getId()" class="dropdown dropright" style="position: absolute;line-height: initial;z-index: 10001">
      <div class="skinnedmenu dropdown-menu">
        <a class="dropdown-item" data-boundary="viewport" v-for="item in config.menu" @click="addDisplayer(item.command)">{{item.text}}</a>
      </div>
    </div>
    <div v-bind:id="'c' + getId()" v-bind:class="config.customclass" data-popup="tooltip" title="" data-placement="left" data-original-title="" v-bind:style="config.customstyle" class="filter-title text-center" style="position:absolute;z-index:1">
      <span class="filteraction" v-if="config.abbreviation != null" v-bind:data-toggle="getToggle" data-boundary="viewport" v-bind:data-target="'#menu' + getId()" @click="toggleActivation" @mouseover="hoverOver">{{config.abbreviation}}</span>
      <img class="filteraction" v-if="config.icon != null" data-boundary="viewport" v-bind:src="config.icon" width="50%" v-bind:data-toggle="getToggle" v-bind:data-target="'#menu' + getId()" @click="toggleActivation" @mouseover="hoverOver" />
      <i class="filteraction" v-if="config.cssIcon != null" data-boundary="viewport" v-bind:class="config.cssIcon" v-bind:data-toggle="getToggle" v-bind:data-target="'#menu' + getId()" @click="toggleActivation" @mouseover="hoverOver" style="margin-top:-4px;z-index:1001" />
      <a v-if="config.disabled != true" @click="removeMe" class="filter-badge badge badge-pill" style="z-index: 1001">-</a>
      <a v-if="config.disabled == true" @click="cantRemove" class="filter-badge badge badge-pill" style="z-index: 1001">-</a>
    </div>

    <span class="font-size-sm text-muted mt-2 filter-mobile-small" style="display:block;overflow:visible;position:absolute;" v-html="config.text"></span>

  </div>
</template>

<script>

  var classes = [];
  var showmenu = false;
  

  export default {
    name: "filter-button",
    components: {
      
    },
    props: {
      type: {
        required: false,
        type: String,
        default: ""
      },
      config: {
        required: false,
        type: Object,
        default() {
          return {
            customstyle: "bg-color:green",
            customclass: "",
            data: 8,
            text: "something",
            icon: null,
            abbreviation: null,
          }
        },
        menu:[]
      }
    },
    data() {
      return {
        classes,
        showmenu
      };
    },
    
    methods: {
      addDisplayer(command) {
        this.$emit('activate', this.type, this.config, command);
      },
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {
        
        this.showmenu = !this.showmenu;
        //alert('activate');
        //this.showmenu = !this.showmenu;
        if (this.config.menu == null)
          this.$emit('activate', this.type, this.config);
      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe(e) {
        $('#c' + this.getId()).tooltip('hide');
        this.$emit('remove', this.getId());
        //e.preventdefault();
      },
      cantRemove() {
        alert('This filter is locked for your user account');
      },
      hoverOver: function () {
        /*
        console.log('over');
        this.classes = [];
        setTimeout(() => {
          console.log('out');
          //this.classes = ['animated', 'bounceIn']
        }, 1000);
        */
      },
      hoverOut: function () {
        /*
        console.log('out');
        this.classes = []
        */
      },
      hoverOutTimeout: function () {
        /*
        setTimeout(() => {
          console.log('out');
          this.classes = []
        }, 1000);
        */
      },
      
    },
    computed: {
      getToggle: function () {
        if (this.config.menu != null && this.config.menu.length > 0)
          return "dropdown";

        return null;
      },
      getToolTip: function () {
        if (this.config.menu != null && this.config.menu.length > 0)
          if ($('#menu' + this.getId()).hasClass('show'))
            return null;
        return "olle";
      }
    },
    mounted() {
     
    },

    created: function () {

    },

    watch: {
     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .filteraction{
      cursor:pointer;
  }

  .filterbutton-container {
    margin-left: 15px;
    z-index: auto;
    display: inline-block;
    position: relative;
    width:40px;
    height:40px;
    margin:auto;
    overflow:visible;
    margin-left:10px;
  }

  .filter-badge {
    line-height: 10px;
    font-family: Arial;
    font-size: 12px;
  }

  .filter-badge {
    position: absolute;
    top: -5px;
    right: 0px;
    background-color: #F7F9F9 !important;
    border-color: #9FACAC !important;
    color: #838787 !important;
    cursor: pointer;
    padding-top: 3px;
    padding-bottom: 5px;
    border: 1px solid #838787;
  }

  .filter-title {
    position: absolute;
    width: 40px;
    height: 40px;
    display: block;
    line-height: 40px;
    -moz-border-radius: 30px;
    border-radius: 30px;
    background-color: black;
    color: white;
    text-align: center;
    font-size: 22px;
  }

  .filter-mobile-small {
    max-width: 40px;
    top:30px;
    z-index:100;
    width:100%;
    font-size:8px;
  }


  @media screen and (max-width:768px) {
    .filterbutton-container {
      margin-left: 5px;
      margin-top:10px;
      height:50px
    }
    .filter-title {
      width: 40px;
      height: 40px;
      line-height: 40px;
      font-size: 10px;
    }
    .font-size-sm{
        font-size:10px;
    }
    .filter-mobile-small {
      max-width: 45px;
      top: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/filter-button-small.vue